/**
 *
 * Asynchronously loads the component for Onboarding
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { Loading } from 'components/Loading'

export default loadable({
  loader: () => import('./index' /* webpackChunkName: "Onboarding" */),
  loading: <Loading />
})
